<template>
    <div class="filter-inline">
        <!-- hide until confirmed to show-->
        <md-field v-show="false" class="filter-field">
            <label class="field-label">Find:</label>
            <md-select id="findBy-select" v-model="findBy">
                <md-option key="findBy-team" value="team">
                    Teams
                </md-option>
                <md-option key="findBy-user" value="user">
                    Standalone Users
                </md-option>
            </md-select>
        </md-field>
        <md-field class="filter-field">
            <label class="field-label">Team Status:</label>
            <md-select id="team-status-select" v-model="teamStatus">
                <md-option key="team-status-All" value="all">All</md-option>
                <md-option key="team-status-Active" value="Active">Active</md-option>
                <md-option key="team-status-Disabling" value="Disabling">Disabling</md-option>
                <md-option key="team-status-Disabled" value="Disabled">Disabled</md-option>
                <md-option key="team-status-Trial" value="Trial">Trial</md-option>
            </md-select>
        </md-field>
        <md-field class="filter-field">
            <label class="field-label">Billing Status:</label>
            <md-select id="billing-status-select" v-model="billingStatus">
                <md-option key="billing-status-All" value="all">All</md-option>
                <md-option key="billing-status-active" value="active">active</md-option>
                <md-option key="billing-status-unpaid" value="unpaid">unpaid</md-option>
                <md-option key="billing-status-canceled" value="canceled">canceled</md-option>
                <md-option key="billing-status-free" value="free">free</md-option>
                <md-option key="billing-status-trialing" value="trialing">trialing</md-option>
                <md-option key="billing-status-cancelled" value="cancelled">cancelled</md-option>
                <md-option key="billing-status-past_due" value="past_due">past_due</md-option>
            </md-select>
        </md-field>
    </div>
</template>

<script>
export default {
    name: 'BillingAccountsFilter',
    data() {
        return {
            findBy: 'team',
            teamStatus: 'Active',
            billingStatus: 'all'
        };
    },
    watch: {
        teamStatus(newVal) {
            this.raiseEvent();
        },
        billingStatus(newVal) {
            this.raiseEvent();
        }
    },
    methods: {
        async raiseEvent() {
            const args = {
                findBy: this.findBy,
                teamStatus: this.teamStatus === 'all' ? '' : this.teamStatus,
                billingStatus: this.billingStatus === 'all' ? '' : this.billingStatus
            };
            this.$emit('onChanged', args);
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .filter-field {
    display: inline-block;
    width: 200px;
    margin-right: 20px;
}
</style>
